import React, { useState, useEffect } from "react";

const LeaveDetail = () => {
  const [fromDate, setFromDate] = useState("2024-12-13");
  const [toDate, setToDate] = useState("2024-12-13");
  const [noOfDays, setNoOfDays] = useState(1);
  const [dayType, setDayType] = useState("Full Day");
  const [fromTime, setFromTime] = useState("08:00:00");
  const [toTime, setToTime] = useState("17:30:00");
  const [hours, setHours] = useState<any>(8.0);
  const [minutes, setMinutes] = useState(480);

  useEffect(() => {
    const [fromH, fromM] = fromTime.split(":").map(Number);
    const [toH, toM] = toTime.split(":").map(Number);

    let totalMinutes = toH * 60 + toM - (fromH * 60 + fromM);
    if (totalMinutes < 0) totalMinutes += 24 * 60;

    setMinutes(totalMinutes);
    setHours((totalMinutes / 60).toFixed(2));
  }, [fromTime, toTime]);

  const dayTypes = ["Full Day", "Morning", "Afternoon", "Evening", "Night"];

  return (
    <div className="max-w-md p-4 bg-white shadow-md rounded-md border">
      <h2 className="text-lg font-bold mb-2 bg-blue-900 text-white p-2 rounded">Leave Detail</h2>
      <div className="grid grid-cols-2 gap-4 mb-4">
        <div>
          <label>From</label>
          <input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} className="w-full border p-1 rounded" />
        </div>
        <div>
          <label>To</label>
          <input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} className="w-full border p-1 rounded" />
        </div>
        <div>
          <label>No. Of Day</label>
          <input type="number" value={noOfDays} onChange={(e) => setNoOfDays(Number(e.target.value))} className="w-full border p-1 rounded" />
        </div>
      </div>

      <div className="grid grid-cols-3 gap-2 mb-4">
        {dayTypes.map((type) => (
          <button key={type} className={`border rounded py-1 px-2 text-sm ${dayType === type ? "bg-blue-900 text-white" : ""}`} onClick={() => setDayType(type)}>
            {type}
          </button>
        ))}
      </div>

      <div className="grid grid-cols-2 gap-4 mb-2">
        <div>
          <label>From time</label>
          <input type="time" value={fromTime} onChange={(e) => setFromTime(e.target.value)} className="w-full border p-1 rounded" />
        </div>
        <div>
          <label>To Time</label>
          <input type="time" value={toTime} onChange={(e) => setToTime(e.target.value)} className="w-full border p-1 rounded" />
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div>
          <label>No. of Hours</label>
          <input type="number" readOnly value={hours} className="w-full border p-1 rounded bg-gray-100" />
        </div>
        <div>
          <label>No. of Minutes</label>
          <input type="number" readOnly value={minutes} className="w-full border p-1 rounded bg-gray-100" />
        </div>
      </div>
    </div>
  );
};

export default LeaveDetail;
